import { DCBaseMouseEvent } from "./DCBaseMouseEvent.js";
export class DCMouseDownEvent extends DCBaseMouseEvent {
    eventType = "mouse-down";
    inputType = "mouse";
    constructor() {
        super();
    }
}
